import Phaser from 'phaser';
import { audio } from '../game/AudioManager.js';
import { questManager } from '../game/QuestManager.js';
import { STORY_CANON } from '../data/story.js';

export class MontageScene extends Phaser.Scene {
  constructor() {
    super('MontageScene');
  }

  create() {
    questManager.show(false);
    audio.playTheme('menu');

    const { width, height } = this.scale;

    // Rich Lavender & Midnight Romantic Background
    const bg = this.add.graphics();
    bg.fillGradientStyle(0x190826, 0x190826, 0x3b1740, 0x3b1740, 1);
    bg.fillRect(0, 0, width, height);

    // Rose petal emitter
    this.add.particles(0, 0, 'petal_particle', {
      x: { min: 0, max: width },
      y: 0,
      lifespan: 8000,
      speedY: { min: 30, max: 70 },
      speedX: { min: -15, max: 15 },
      scale: { start: 1.5, end: 0.5 },
      alpha: { start: 0.7, end: 0.1 },
      quantity: 1,
      frequency: 200
    });

    const title = this.add.text(width / 2, 70, 'TEN YEARS OF LOVE (2016 — 2026)', {
      fontFamily: 'Georgia, serif',
      fontSize: '32px',
      color: '#ffd166',
      fontStyle: 'bold'
    }).setOrigin(0.5);

    // Container for montage slideshow cards
    let currentIdx = 0;
    const years = STORY_CANON.montageYears;

    const card = this.add.container(width / 2, height / 2);

    const cardBg = this.add.rectangle(0, 0, 760, 390, 0x1d0f28, 0.95)
      .setStrokeStyle(2, 0xff70a6);
    card.add(cardBg);

    const yearLabel = this.add.text(0, -135, years[0].year, {
      fontFamily: 'Georgia, serif',
      fontSize: '56px',
      color: '#ff70a6',
      fontStyle: 'bold'
    }).setOrigin(0.5);
    card.add(yearLabel);

    const titleLabel = this.add.text(0, -85, years[0].title, {
      fontFamily: 'Trebuchet MS, Arial, sans-serif',
      fontSize: '22px',
      color: '#ffd166',
      fontStyle: 'bold'
    }).setOrigin(0.5);
    card.add(titleLabel);

    const descLabel = this.add.text(0, -30, years[0].desc, {
      fontFamily: 'Georgia, serif',
      fontSize: '19px',
      color: '#fdf2f8',
      align: 'center',
      lineSpacing: 6,
      wordWrap: { width: 620 }
    }).setOrigin(0.5);
    card.add(descLabel);

    // Characters standing side-by-side below the text, completely separated from the reading area
    const talhaMini = this.add.sprite(-45, 85, 'talha_sheet', 0).setScale(0.38).play('talha_idle');
    const emilyMini = this.add.sprite(45, 85, 'emily_sheet', 0).setScale(0.38).setFlipX(true).play('emily_idle');
    card.add(talhaMini);
    card.add(emilyMini);

    // Floating heart between them
    const heartIcon = this.add.text(0, 75, '❤️', { fontSize: '20px' }).setOrigin(0.5);
    card.add(heartIcon);
    this.tweens.add({
      targets: heartIcon,
      scale: 1.25,
      y: 70,
      duration: 800,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut'
    });

    // Soft grounded shadows under characters
    const shadowTalha = this.add.ellipse(-45, 130, 38, 9, 0x000000, 0.4);
    const shadowEmily = this.add.ellipse(45, 130, 38, 9, 0x000000, 0.4);
    card.add(shadowTalha);
    card.add(shadowEmily);

    const progressLabel = this.add.text(0, 162, `1 / ${years.length}  — [Click or Next]`, {
      fontSize: '13px',
      color: '#c4b5fd'
    }).setOrigin(0.5);
    card.add(progressLabel);

    const advance = () => {
      currentIdx++;
      if (currentIdx < years.length) {
        audio.playClick();
        const item = years[currentIdx];
        yearLabel.setText(item.year);
        titleLabel.setText(item.title);
        descLabel.setText(item.desc);
        progressLabel.setText(`${currentIdx + 1} / ${years.length}  — [Click or Next]`);

        // Small pulse
        this.tweens.add({
          targets: card,
          scaleX: 1.03,
          scaleY: 1.03,
          duration: 150,
          yoyo: true
        });
      } else {
        // Transition to Level 3: The Knight Battles (Rescue Queen Emily)
        audio.playRomanticChime();
        this.cameras.main.fade(1000, 0, 0, 0);
        this.cameras.main.once('camerafadeoutcomplete', () => {
          this.scene.start('Level3Scene');
        });
      }
    };

    this.input.on('pointerdown', advance);
    this.input.keyboard.on('keydown-SPACE', advance);
    this.input.keyboard.on('keydown-ENTER', advance);

    // Skip directly to Knight Battles
    const skipBtn = this.add.text(width - 50, height - 40, 'SKIP TO BATTLES >', {
      fontSize: '16px',
      color: '#aaa',
      backgroundColor: '#1b0d2a',
      padding: { x: 10, y: 5 }
    }).setOrigin(1).setInteractive({ useHandCursor: true });

    skipBtn.on('pointerdown', () => {
      this.scene.start('Level3Scene');
    });
  }
}
